module.exports = __webpack_public_path__ + "757f327faa1b31b5b76be4da4b0e48da.pdf";